import { Controller } from "@hotwired/stimulus"
import { Collapse } from 'bootstrap'

// Connects to data-controller="collapse"
export default class extends Controller {
  static values = {
    target: String,
    opened: Boolean
  }

  connect() {
    const myCollapse = document.getElementById(this.targetValue)
    const bsCollapse = new Collapse(myCollapse, {
      show: this.openedValue
    })
  }
}
